import axios from "axios";

// Create a custom Axios instance
const api = axios.create({
    baseURL: "//",
    timeout: 60000,
    headers: {
        "Content-Type": "application/json",
    },
});

// Get CSRF token from Django
function getCookie(name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
}

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // If it's not a GET request, attach the CSRF token
        if (config.method !== "get") {
            config.headers["X-CSRFToken"] = getCookie("csrftoken");
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;
